import { render, staticRenderFns } from "./bucketList.vue?vue&type=template&id=18d25681&scoped=true&"
import script from "./bucketList.vue?vue&type=script&lang=js&"
export * from "./bucketList.vue?vue&type=script&lang=js&"
import style0 from "./bucketList.vue?vue&type=style&index=0&id=18d25681&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d25681",
  null
  
)

export default component.exports